module.exports = __webpack_public_path__ + "static/chubb-logo-5f896241fb8c7031ce71d35314843f39.png";